/**
 * @fileoverview PUT handler for the "/api/calculated_attributes/:id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putApiCalculatedAttributesIdAppGroupIdCacheKeys } from "./constants";
import type {
  PutApiCalculatedAttributesIdAppGroupIdProps,
  PutApiCalculatedAttributesIdAppGroupIdResult,
  PutApiCalculatedAttributesIdAppGroupIdResultErrors,
} from "./types";

export const putApiCalculatedAttributesIdAppGroupId = reactQueryMutationAdapter(
  putApiCalculatedAttributesIdAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PutApiCalculatedAttributesIdAppGroupIdResultErrors>()(
    (props: PutApiCalculatedAttributesIdAppGroupIdProps): Promise<PutApiCalculatedAttributesIdAppGroupIdResult> => {
      return fetch(
        `/api/calculated_attributes/${props.calculatedAttributeId}/${props.appGroupId}`,
        "PUT",
        { calculated_attribute: props.calculated_attribute },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
